import React from 'react';
import { MORE_FILTERS_LIST } from '@/constants';
import { removeFilter, loadFilters } from './filtersStorage';

interface FilterObject {
  [key: string]: any;
}

export const getMoreFilterValues = (moreFilters: any) => {
  let moreFiltersValues = {};
  moreFilters.forEach((element: string) => {
    const item = MORE_FILTERS_LIST.find((x) => x.value === element);
    if (item && item.key) {
      const filter: FilterObject = {};
      filter[item.key] = true;
      moreFiltersValues = {
        ...moreFiltersValues,
        ...filter,
      };
    }
  });
  return moreFiltersValues;
};

export const filterMultiToggleValues = (event: React.SyntheticEvent, toggleValues: any) => {
  const { value } = event.target as HTMLInputElement;
  const existing = toggleValues.find((element: string) => element === value);
  const update: string[] = toggleValues.map((x: string) => x);
  if (existing === undefined) {
    update.push(value);
  } else {
    update.splice(
      update.findIndex((element) => element === value),
      1
    );
    const item = MORE_FILTERS_LIST.find((x) => x.value === value);
    if (item && item.key) {
      removeFilter(item.key);
    }
  }
  return update;
};

/*
 * Moving filter to top when its on bottom of screen in small screens
 */
export const handleFilterAnimation = (isMobile: boolean, ref: any, navID: string) => {
  if (isMobile) {
    /**
     * Scroll filter to top of page accounting for the height of the sticky nav and some additional padding
     */
    const element = ref.current;
    if (element) {
      const filteringOffSetY =
        (window.scrollY || window.pageYOffset) + element.getBoundingClientRect().top;
      const navMain = document.querySelector(navID);
      const navHeight = navMain ? navMain.scrollHeight : 0;
      window.scrollTo(0, filteringOffSetY - navHeight);
    }
  }
};
export const getFilterData = () => {
  const data = { displayFilter: false, moreFilter: false, jobDetailsFilter: false };
  const filters = loadFilters();
  if (filters) {
    const filterKeys = Object.keys(filters).filter((x: string) => {
      let returnVal = false;
      if (x !== 'radius' && filters[x] !== null && !Number.isNaN(filters[x])) {
        returnVal = true;
      }
      if (typeof filters[x] === 'string' && filters[x].length > 0) {
        returnVal = true;
      }
      return returnVal;
    });
    data.displayFilter = filterKeys.length > 0;
    data.moreFilter = filterKeys.includes('nonSmoker') || filterKeys.includes('hasCar');
    data.jobDetailsFilter =
      filterKeys.includes('newJobsOnly') || filterKeys.includes('jobStartingSoon');
  }
  return data;
};
